import { render, staticRenderFns } from "./SkeletonTeam.vue?vue&type=template&id=3ab2a1c6&"
import script from "./SkeletonTeam.vue?vue&type=script&lang=js&"
export * from "./SkeletonTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SkeletonTeam.vue"
export default component.exports